import { GLOBAL_THEME_COLOR } from '@constants/theme';
import { useRealTime } from '@core/hooks';
import { Reservation, ReservationStatus } from '@core/models';
import moment from 'moment';
import React, { useMemo } from 'react';

type Props<T> = {
  reservation: Reservation<T>;
};

function ReservationTimeRender<T>({ reservation }: Props<T>) {
  const { now } = useRealTime();
  const reservedDate = useMemo(() => moment(reservation.reserved_date), [reservation]);

  const isPassed = useMemo(() => {
    return reservedDate.isBefore(now);
  }, [reservedDate, now]);

  const [time, amORpm] = useMemo(() => {
    const [time, hour] = reservedDate.format('hh:mm A').split(' ');
    return [time, hour];
  }, [reservedDate]);
  return (
    <div>
      <span
        style={{
          color:
            reservation.status === ReservationStatus.Waiting
              ? isPassed
                ? GLOBAL_THEME_COLOR.$error_color
                : GLOBAL_THEME_COLOR.$highlight_color
              : GLOBAL_THEME_COLOR.$dark_text_color,
          fontWeight: '600',
          fontSize: '15px',
        }}>
        {time}
      </span>
      <span
        style={{
          color: GLOBAL_THEME_COLOR.$dark_text_color,
          marginLeft: 5,
          fontSize: '12px',
        }}>
        {amORpm}
      </span>
    </div>
  );
}

export default ReservationTimeRender;
